.emojiPanel aside {
  --epr-emoji-size: 28px;
  --epr-emoji-padding: 4px;
  --epr-category-label-height: 1px;

  width: 100%;
  max-width: 100%;
}

.emojiPanel :global(.epr-emoji-category-label) {
  visibility: hidden;
  height: 1px;
}
